import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/product-management/_layout/inactive")({
  beforeLoad: () => {
    throw redirect({
      to: "/product-management/inbox",
      replace: true,
    })
  },
})
